import { Globe, Users } from "lucide-react";
import { useState } from "react";
import { tv } from "tailwind-variants";
import { API_URLS } from "@/config/urls";

const toggleButton = tv({
  base: "flex items-center gap-2 rounded-full px-4 py-1.5 text-sm",
  variants: {
    isActive: {
      true: "bg-rw-main text-white [&>svg]:text-white",
      false: "text-rw-dark-gray hover:bg-gray-100 [&>svg]:text-rw-dark-gray",
    },
  },
});

export const AppToggle = () => {
  const [isRuleWatch, setIsRuleWatch] = useState(false);

  const handleRuleWatchClick = () => {
    setIsRuleWatch(true);

    window.location.href = API_URLS.WHALE;
  };

  return (
    <div className="flex h-9 items-center justify-center rounded-full bg-white p-0.5">
      <button
        type="button"
        className={toggleButton({ isActive: isRuleWatch })}
        onClick={handleRuleWatchClick}
      >
        <Globe className="size-5" />
        <span>RuleWatch</span>
      </button>

      <div className={toggleButton({ isActive: !isRuleWatch })}>
        <Users className="size-5" />
        <span>Study Group Lounge</span>
      </div>
    </div>
  );
};
